import React, { useState } from 'react';
import css from './CostSummaryHeaderStep2.module.css';
import {
    notifyErrorCustom,
    notifySuccessCustom,
} from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { ViewItemTypesModeType } from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import CircularArrowsIcon from '@shared/Icons/CircularArrowsIcon';
import ViewModeSwitcher from '@modules/Steps/Shared/Widgets/ViewModeSwitcher/ViewModeSwitcher';
import { useParams } from 'react-router-dom';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { CustomProjectStep2ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep2ElementsIdsEnum';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { useFragmentsStore } from '../../../../../Stores/FragmentsStore';
import classNames from 'classnames';

interface CostSummaryHeaderProps {
    itemTypesViewMode: ViewItemTypesModeType;
}

export const CostSummaryHeaderStep2: React.FC<CostSummaryHeaderProps> = ({
    itemTypesViewMode,
}) => {
    const { viewMode, projectId } = useParams();
    const { isMinimumPriceLoading, isResetProjectLoading } =
        useFragmentsStore();

    const fragmentsViewModel = new FragmentsViewModel();

    const handleShowMinimumPrice = async () => {
        const isSuccess =
            await fragmentsViewModel.getMinimumPriceProjectWithParsedFragments(
                Number(projectId)
            );

        if (isSuccess) {
            notifySuccessCustom(
                'You have successfully added products with minimum price to the project'
            );
            return;
        }

        notifyErrorCustom(
            'Failed to add products with minimum price to the project'
        );
    };

    const handleFlush = async () => {
        const isSuccess =
            await fragmentsViewModel.getFlushProjectWithParsedFragments(
                Number(projectId)
            );
        if (isSuccess) {
            notifySuccessCustom('You have successfully reset the project!');
            return;
        }

        notifyErrorCustom('Failed to reset the project');
    };

    return (
        <div className={css.costSummaryHeaderWrapper}>
            <p className={css.costSummary}>Cost summary</p>

            <div className={css.costSummarySwitcher}>
                <ViewModeSwitcher viewMode={itemTypesViewMode} />
            </div>

            <div className={css.costSummaryBtns}>
                <BasicButton
                    key="minimum-price"
                    onClick={handleShowMinimumPrice}
                    extraClassName={classNames(css.minPriceBtn, {
                        [css.disabled]:
                            isMinimumPriceLoading ||
                            isResetProjectLoading ||
                            viewMode === StepsViewModeEnum.PRESENTATION,
                    })}
                    id={
                        CustomProjectStep2ElementsIdsEnum.WORK_AREA_STEP2_MINIMUM_PRICE_BUTTON
                    }
                >
                    <CircularArrowsIcon
                        height={18}
                        width={18}
                        fill="currentColor"
                        className={
                            isMinimumPriceLoading
                                ? css.rotatedBtnIcon
                                : css.btnIcon
                        }
                    />
                    Minimum price
                </BasicButton>

                <BasicButton
                    key="flush"
                    onClick={handleFlush}
                    extraClassName={classNames(css.flushBtn, {
                        [css.disabled]:
                            isMinimumPriceLoading ||
                            isResetProjectLoading ||
                            viewMode === StepsViewModeEnum.PRESENTATION,
                    })}
                    id={
                        CustomProjectStep2ElementsIdsEnum.WORK_AREA_STEP2_FLUSH_BUTTON
                    }
                >
                    <CircularArrowsIcon
                        height={18}
                        width={18}
                        fill="currentColor"
                        className={
                            isResetProjectLoading
                                ? css.rotatedBtnIcon
                                : css.btnIcon
                        }
                    />
                    Reset
                </BasicButton>
            </div>
        </div>
    );
};
